module.exports = __webpack_public_path__ + "img/avatar7.2e969407.png";